import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';

/**
 * LoadingBox - A reusable atom component to display a centered loading indicator with text
 * 
 * @param {Object} props
 * @param {string} props.message - Loading message to display
 * @param {number} props.spinnerSize - Size of the CircularProgress indicator
 * @param {Object} props.sx - Additional styling for the outer Box
 */
const LoadingBox = ({ 
  message = 'Loading...', 
  spinnerSize = 24, 
  sx = {} 
}) => {
  return (
    <Box 
      sx={{ 
        p: 2, 
        textAlign: 'center', 
        backgroundColor: '#f9f9f9', 
        borderRadius: 0,
        ...sx
      }}
    >
      <Typography color="text.secondary">
        {message}
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
        <CircularProgress size={spinnerSize} />
      </Box>
    </Box>
  );
};

export default LoadingBox;
